import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { AppConfig } from '../_helpers';
import { CustomHttpUrlEncodingCodec } from '../encoder';
import { PayoutConfirmedResponse, PayoutListResponse, PayoutListToConfirm } from '../_models/massive-payout-confirmation-process';

@Injectable({
  providedIn: 'root'
})
export class PayoutProcessCommerceMasiveConfirmService {

  private _kcmssvcURL: string = AppConfig.settings.apiServer.kcmssvcURL.toString();

  constructor(
    private httpClient: HttpClient
  ) {
  }

  updateValue(payoutList: any[]) {
    const payoutsSelected = this.processPayoutsSelected(payoutList);
    return payoutsSelected;
  }

  private processPayoutsSelected(payoutList: any[]): { customer_public_ids: string, payout_public_ids: string } {
    try {
      const customerPublicIds = this.convertIds(payoutList, 'company.public_id');
      const payoutPublicIds = this.convertIds(payoutList, 'public_id');
      return { customer_public_ids: customerPublicIds, payout_public_ids: payoutPublicIds };
    } catch (error) {
      console.error('Error trying get customers ids and payouts ids', error);
      return { customer_public_ids: null, payout_public_ids: null };
    }
  }

  private convertIds(list: any[], key: string): string {
    return list.map(el => this.getNestedValue(el, key)).join(',');
  }

  private getNestedValue(obj: any, key: string): any {
    return key.split('.').reduce((acc, part) => acc && acc[part], obj);
  }

  public getPayoutsToConfirmList(customersIds: string, payoutsIds: string): Observable<PayoutListResponse[]> {
    let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });

    if (customersIds != undefined && customersIds != '') {
      queryParameters = queryParameters.set('customer_public_ids', <string>customersIds);
    }

    if (payoutsIds != undefined && payoutsIds != '') {
      queryParameters = queryParameters.set('payout_public_ids', <string>payoutsIds);
    }

    return this.httpClient.get<PayoutListResponse[]>(`${this._kcmssvcURL}/payouts/confirm`, { params: queryParameters });
  }

  public confirmPayoutList(payoutList: PayoutListToConfirm[]): Observable<HttpResponse<PayoutConfirmedResponse>> {
    return this.httpClient.post<PayoutConfirmedResponse> (`${this._kcmssvcURL}/payouts/confirm`, payoutList, {
      observe: 'response',
    });
  }

}
